// extracted by mini-css-extract-plugin
module.exports = {"title":"style-module_title_3pUL0","method":"style-module_method_3OyRb","methodInactive":"style-module_methodInactive_3AVbt"};